var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userInfo.area === 'JP')?_c('div',{class:_vm.$style.tips,domProps:{"innerHTML":_vm._s(
            _vm.$t('users.query_data_large_tips', {
                link: _vm.link
            })
        )}}):_c('div',{class:_vm.$style.tips,domProps:{"innerHTML":_vm._s(_vm.$t('users.query_data_large_tips_en'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }